import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  Field,
  FormSection,
  formValueSelector,
  change,
} from 'redux-form';
import InputField from '../../form/InputField';
// import TaskStatusEditor from './TaskStatusEditor';

const TaskStatusFormSelector = (state, props) => {
  const selector = formValueSelector(props.uid || props.form);
  return selector(state, 'typeOptions', 'propValue', 'field');
};

const TaskStatusComponentSelector = createSelector(
  [TaskStatusFormSelector],
  taskStatusForm => ({
    fields: taskStatusForm,
  }),
);

@connect(TaskStatusComponentSelector)
export default class TaskStatusDesigner extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    uid: PropTypes.string,
    input: PropTypes.object,
    fields: PropTypes.object,   // options and default value
    value: PropTypes.object,
    labelClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
    userMode: PropTypes.string,
  };

  setListOptions = value => value && value.split(/\r?\n/);

  listOutput = value => {
    if (value && Array.isArray(value)) {
      return value.join('\n');
    }
    return value;
  };

  // handleDesignerOnChange = value => {
  //   const {
  //     uid,
  //     dispatch,
  //     fields: { typeOptions, propValue },
  //   } = this.props;

  //   // dispatch(change(uid, 'typeOptions.statuses', this.setListOptions(value)));

  //   if ((typeof typeOptions === 'object' &&
  //       (typeOptions && typeOptions.statuses) &&
  //       Array.isArray(typeOptions.statuses) &&
  //       typeOptions.statuses.length >= 1)
  //   ) {
  //     if ((propValue && !propValue.status) || !propValue) {
  //       dispatch(change(uid, 'propValue.status', typeOptions.statuses[0]));
  //     }

  //     if (
  //       typeOptions.statuses[typeOptions.statuses.length - 1] === value &&
  //       (propValue && !propValue.reason && typeOptions.reasons.length >= 1)
  //     ) {
  //       dispatch(change(uid, 'propValue.reason', propValue.reasons[0]));
  //     }
  //   }
  // };

  handleDesignerOnChangeReason = () => {
    const {
      uid,
      dispatch,
      fields: { typeOptions, propValue },
    } = this.props;

    // dispatch(change(uid, 'typeOptions.reasons', this.setListOptions(value)));

    if ((typeof typeOptions === 'object' &&
        (typeOptions && typeOptions.statuses && typeOptions.reasons) &&
        Array.isArray(typeOptions.statuses) &&
        Array.isArray(typeOptions.reasons) &&
        typeOptions.statuses.length >= 1 &&
        typeOptions.reasons.length >= 1 &&
        (propValue && propValue.status &&
          propValue.status === typeOptions.statuses[typeOptions.statuses.length - 1]))
    ) {
      dispatch(change(uid, 'propValue.reason', typeOptions.reasons[0]));
    }
  };

  render = () => {
    const {
      // dispatch,
      // input,
      // uid,
      // fields: { typeOptions },
      labelClassName,
      wrapperClassName,
      wrapperStyle,
      containerClassName,
      containerStyle,
    } = this.props;

    // const label = <label className={labelClassName}>Default Value</label>;
    // const designer = null;
    const designer = (
      <div>
        <div className={`pb-3 ${wrapperClassName}`} style={wrapperStyle}>
          {/* <label className={labelClassName}>List Options</label> */}
          <label className={labelClassName}>Reason for Incomplete Options</label>
          <div className={containerClassName} style={containerStyle}>
            <FormSection name="typeOptions">
              {/*
              <Field
                name="statuses"
                type="textarea"
                component={InputField}
                className="form-control"
                style={{ width: '100%' }}
                normalize={this.setListOptions}
                format={this.listOutput}
                onChange={e => {
                  this.handleDesignerOnChange(e.target.value);
                }}
              />
              <div className="d-block mb-2">
                <em style={{ fontSize: '80%' }}>
                  If the last option is selected, a reason must be provided.
                </em>
              </div>
              */}
              {/*
              <label
                className="d-block mb-2"
                style={{ fontSize: 14, fontFamily: 'Arial' }}
              >
                Reason for Incomplete Options
              </label>
              */}
              <div className="input-group d-block mb-2">
                <Field
                  name="reasons"
                  type="textarea"
                  component={InputField}
                  className="form-control"
                  style={{ width: '100%' }}
                  normalize={this.setListOptions}
                  format={this.listOutput}
                  onChange={e => {
                    this.handleDesignerOnChangeReason(e.target.value);
                  }}
                />
              </div>
            </FormSection>
          </div>
        </div>
      </div>
    );

    return designer;

    // console.log('inpppppp', input);
    // return (
    //   <div>
    //     {designer}
    //     <div className={wrapperClassName} style={wrapperStyle}>
    //       {label}
    //       <div className={containerClassName} style={containerStyle}>
    //         <TaskStatusEditor
    //           uid={uid}
    //           propTypeOptions={typeOptions}
    //           designerMode
    //           input={input}
    //           dispatch={dispatch}
    //         />
    //       </div>
    //     </div>
    //   </div>
    // );
  };
}



// WEBPACK FOOTER //
// ./src/components/types/TaskStatus/TaskStatusDesigner.js